import { render, staticRenderFns } from "./createChainAddr.vue?vue&type=template&id=365caddc&scoped=true"
import script from "./createChainAddr.vue?vue&type=script&lang=js"
export * from "./createChainAddr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365caddc",
  null
  
)

export default component.exports